import { Languages } from "lucide-react";
import { useI18n, LANGS } from "@/lib/i18n";

const LABELS = { es: "Castellano", ca: "Català" };
const SHORT = { es: "ES", ca: "CA" };

/**
 * LanguageSwitcher · pill toggle ES / CA
 *
 * - Compact pill in the header (desktop + mobile)
 * - Accessible: keyboard navigable + aria-pressed
 */
const LanguageSwitcher = ({ variant = "header" }) => {
  const { lang, setLang } = useI18n();

  if (variant === "footer") {
    return (
      <div className="flex items-center gap-2 text-xs" data-testid="lang-switcher-footer">
        <Languages size={13} className="text-ivory/55" />
        {LANGS.map((l, i) => (
          <button
            key={l}
            type="button"
            onClick={() => setLang(l)}
            data-testid={`lang-btn-footer-${l}`}
            aria-pressed={lang === l}
            className={`uppercase tracking-[0.18em] transition-colors ${
              lang === l ? "text-terracotta" : "text-ivory/55 hover:text-ivory"
            }`}
          >
            {SHORT[l]}
            {i < LANGS.length - 1 && <span className="text-ivory/30 ml-2">·</span>}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center rounded-full border border-charcoal/15 bg-cream/40 p-1 backdrop-blur-sm"
      role="group"
      aria-label="Selecciona idioma · Selecciona idioma"
      data-testid="lang-switcher"
    >
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          data-testid={`lang-btn-${l}`}
          aria-pressed={lang === l}
          title={LABELS[l]}
          className={`px-2.5 py-1 text-[11px] font-semibold tracking-[0.12em] rounded-full transition-all ${
            lang === l
              ? "bg-charcoal text-ivory shadow-sm"
              : "text-charcoal/55 hover:text-charcoal"
          }`}
        >
          {SHORT[l]}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
